export default __webpack_public_path__ + "static/media/4.blur.40a14408.jpeg";